/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import Composer from 'flarum/forum/components/Composer';
import ComposerState from 'flarum/forum/states/ComposerState';
import ReviewComposer from '../components/ReviewComposer';
import { REVIEW_COMPOSER_MIN_HEIGHT } from '../config';

/**
 * The review composer needs more room than a discussion's, and gives it back afterwards.
 */
export default function () {
	extend(ComposerState.prototype, 'load', function () {
		// `ComposerState#body` is typed `Object` by core.
		if ((this.body as { componentClass?: unknown }).componentClass === ReviewComposer) {
			if (this.height < REVIEW_COMPOSER_MIN_HEIGHT) {
				this._oldHeight = this.height;
				this.height = REVIEW_COMPOSER_MIN_HEIGHT;
			}
		} else if (this._oldHeight) {
			this.height = this._oldHeight;
			delete this._oldHeight;
		}
	});
	extend(Composer.prototype, 'changeHeight', function () {
		// `changeHeight()` only ever runs while a state is attached.
		delete this.state!._oldHeight;
	});
}
